import { render, staticRenderFns } from "./TheEventChart.vue?vue&type=template&id=2fe824ad&scoped=true&"
import script from "./TheEventChart.vue?vue&type=script&lang=js&"
export * from "./TheEventChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe824ad",
  null
  
)

export default component.exports